import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Estudo } from '../estudo/estudo';
import { Ocorrencia } from '../ocorrencia/ocorrencia';

@Component({
  selector: 'app-desclassificar-dialog.component',
  templateUrl: './desclassificar-dialog.component.html',
  styleUrls: ['desclassificar-dialog.component.css']
})
export class DesclassificarDialogComponent {
  public list: Estudo[];
  public estudo: Estudo;

  constructor(
    public dialogRef: MatDialogRef<number>,
    @Inject(MAT_DIALOG_DATA) public data: Estudo[]) {
    this.list = data;
    if (this.list.length === 1) {
      this.estudo = this.list[0];
    }
  }

  fechar(): void {
    this.dialogRef.close(false);
  }

  desclassificarEmitido(ocorrencias: Ocorrencia[]) {
    this.dialogRef.close(true);
  }

}
